function getColorFromHexSum(hexSum: number): string {
  const colorIndex = hexSum % 4;

  switch (colorIndex) {
    case 0:
      return 'primary';
    case 1:
      return 'accent';
    case 2:
      return 'success';
    case 3:
      return 'alert';
    default:
      return 'warn';
  }
}

export function GetLimitedHexSum(str: string): string {
  let sum = 0;
  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    if (sum + charCode > 255) {
      break;
    }
    sum += charCode;
  }

  return getColorFromHexSum(sum);
}
